import { Injectable, inject } from "@angular/core";
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    Router,
    UrlTree,
} from "@angular/router";
import { catchError, map, Observable, of, switchMap } from "rxjs";

import { NotificationsService } from "@hermes/aphrodite-layout-state";
import { RESET_PWD_ANGULAR, FeatureFlagFacade } from "@hermes/hermes-web-states-flipper-state";

import { ResetPasswordService } from "../services/reset-password.service";

@Injectable()
export class ResetPasswordGuard implements CanActivate {
    private featureFlagFacade = inject(FeatureFlagFacade);

    private router = inject(Router);
    private notificationsService = inject(NotificationsService);
    private resetPasswordService = inject(ResetPasswordService);

    public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot,
    ): Observable<boolean | UrlTree> {
        return this.featureFlagFacade.isActivated(RESET_PWD_ANGULAR).pipe(
            switchMap((isEnabled) => {
                const hash = route.queryParamMap.get("hash");
                if (!isEnabled || !hash) {
                    return of(
                        this.router.createUrlTree(["/404-error"], {
                            queryParams: { originalUrl: state.url },
                        }),
                    );
                }

                return this.resetPasswordService.verify(hash).pipe(
                    map(() => true),
                    catchError(() => {
                        this.notificationsService.technicalErrorBackToHome();
                        return of(false);
                    }),
                );
            }),
        );
    }
}
